export const getOnlyDigits = (value = "") => value.replace(/\D/g, "");

export const isValidCpf = (cpf = "") => {
    const digits = getOnlyDigits(cpf);
    if (digits.length !== 11 || /^(\d)\1+$/.test(digits)) return false;

    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(digits[i], 10) * (10 - i);
    }

    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(digits[9], 10)) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(digits[i], 10) * (11 - i);
    }

    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;

    return remainder === parseInt(digits[10], 10);
};

export const isValidCnpj = (cnpj = "") => {
    const digits = getOnlyDigits(cnpj);
    if (digits.length !== 14 || /^(\d)\1+$/.test(digits)) return false;

    const calculateDigit = (base: string, weights: number[]) => {
        const sum = base
            .split("")
            .reduce((acc, digit, index) => acc + parseInt(digit, 10) * weights[index], 0);
        const remainder = sum % 11;
        return remainder < 2 ? 0 : 11 - remainder;
    };

    const base = digits.slice(0, 12);
    const firstDigit = calculateDigit(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    const secondDigit = calculateDigit(`${base}${firstDigit}`, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

    return digits === `${base}${firstDigit}${secondDigit}`;
};

export const isValidCpfCnpj = (document = "") => {
    const digits = getOnlyDigits(document);
    if (!digits.length) return false;
    if (digits.length === 11) return isValidCpf(digits);
    if (digits.length === 14) return isValidCnpj(digits);
    return false;
};
